import React from 'react';
import { Async } from 'react-select';
import GraphQLClient from '@api/graphql/GraphQLClient';
import * as Queries from '@api/graphql/queries';
import { ProductAutocomplete } from '@api/graphql/types';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';

export interface ProductIdName {
    id: string;
    name: string;
}
export interface ProductValueLabel {
    value: string;
    label: string;
}

type Props = {
    name: string;
    value: ProductIdName[] | null | undefined;
    onChange: (value: ProductValueLabel) => void;
    selectedProduct: ProductValueLabel;
} & InjectedIntlProps;


interface State {
    value: ProductIdName[] | null | undefined;
    inputValue: string;
    results: Array<{ value: string, label: string }>;
}

class ProductInput extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            value: props.value ? [...props.value] : [],
            inputValue: '',
            results: [],
        };
    }

    private loadOptions = () => {
        const values = this.state.value ? this.state.value.map((val) => val.id) : [];
        return new Promise(resolve => {
            const filters = {
                name: parseInt(this.state.inputValue, 10) ? undefined : this.state.inputValue,
                ext_id: parseInt(this.state.inputValue, 10) ? this.state.inputValue : undefined,
            };

            GraphQLClient.query<ProductAutocomplete>({ query: Queries.productAutocomplete, variables: { filters, count: 30, page: 1 } })
                .then(options => {
                    if (options.data.adminProducts && options.data.adminProducts.data) {
                        const results = (options.data.adminProducts.data.filter((product) => {
                            return !values.includes(product.id);
                        })
                            .map((product) => {
                                return { value: product.id, label: `${product.name} (${product.ext_id})` };
                            }));
                        this.setState({ results });
                        resolve(results);
                    }
                });
        });
    }

    public render() {

        return (
            <>
                <Async
                    placeholder={this.props.intl.formatMessage({ id: 'component.ProductInput.placeholder' })}
                    defaultOptions={this.state.results}
                    loadOptions={this.loadOptions}
                    value={this.props.selectedProduct}
                    inputValue={this.state.inputValue}
                    onInputChange={(query: string) => this.setState({ inputValue: query })}
                    onChange={(selectedProduct: ProductValueLabel) => this.props.onChange(selectedProduct)}
                />
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductInput);



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/components/ProductInput.tsx